import React, { useState } from 'react';
import { generateInitials } from '../../../utils/helpers';
import styles from './MentorAvatar.module.css';

// Photo when there is one (and it loads), otherwise initials on a tinted circle.
const MentorAvatar = ({ mentor, size = 48 }) => {
  const [failed, setFailed] = useState(false);
  const dimension = { width: size, height: size };

  if (mentor.photo_url && !failed) {
    return (
      <img
        className={styles.photo}
        style={dimension}
        src={mentor.photo_url}
        alt=""
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <div
      className={styles.initials}
      style={{ ...dimension, fontSize: Math.round(size * 0.36) }}
      aria-hidden="true"
    >
      {generateInitials(mentor.first_name, mentor.last_name)}
    </div>
  );
};

export default MentorAvatar;
